/*
    格式化金额，
    amount : 金额
    length : 保留位数
*/
export default function formatMoney(amount, length) {
    let s = amount;
    if (s === null || s === undefined || s === '') return '';
    const n = length > 0 && length <= 20 ? length : 2;
    s = `${parseFloat((`${s}`).replace(/[^\d.-]/g, '')).toFixed(n)}`;
    const l = s.split('.')[0].split('').reverse();
    const r = s.split('.')[1];
    let t = '';
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '');
    }
    return `${t.split('').reverse()
        .join('')}.${r}`;
}
